import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDecisionEmbed } from '../../context/DecisionEmbedContext';

const EntscheidungsassistentResource = () => {
  const ctx = useDecisionEmbed();
  const [searchParams] = useSearchParams();

  const src = useMemo(() => {
    const params = new URLSearchParams(searchParams);
    params.set('hostSidebar', '1');
    params.set('apiBase', '/api/decision-matrix');
    const query = params.toString();
    return query ? `/entscheidungsmatrix/index.html?${query}` : '/entscheidungsmatrix/index.html';
  }, [searchParams]);

  const handleLoad = () => {
    ctx?.setEmbedReady?.(true);
    ctx?.postToEmbed?.({ type: 'dm-host-request-state' });
  };

  return (
    <div className="w-full flex-1 flex flex-col min-h-0 bg-hrf-navy/[0.04]">
      <iframe
        title="HR-Kompass"
        src={src}
        ref={ctx?.setIframeEl}
        onLoad={handleLoad}
        className="w-full flex-1 min-h-[520px] border-0 block bg-white"
      />
    </div>
  );
};

export default EntscheidungsassistentResource;
